module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "report_container"
    }
  }, [_c('div', {
    staticClass: "card gl-container-shadow reports-content"
  }, [(_vm.tabs != null && Object.keys(_vm.tabs).length > 0) ? _c('ul', {
    staticClass: "nav nav-tabs report-tabs",
    attrs: {
      "id": "nav_report"
    }
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [_c('a', {
      staticClass: "nav-link active",
      attrs: {
        "id": tab.id,
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.loadTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(index))])])
  })) : _vm._e(), _vm._v(" "), (_vm.tabs != null && Object.keys(_vm.tabs).length > 0) ? _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "id": "frame_report",
      "src": "",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabs == null || Object.keys(_vm.tabs).length === 0) ? _c('div', {
    staticClass: "empty-reports-txt text-left"
  }, [_c('h4', {
    staticClass: "card-title no-reports-copy"
  }, [_vm._v("No Reports")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-324c44d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/Reports.vue
// module id = 503
// module chunks = 1